/**
 * Hook: aktueller Affiliate-Status des eingeloggten Nutzers.
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AffiliateRecord {
  id: string;
  user_id: string;
  affiliate_code: string;
  status: "pending" | "active" | "paused" | "banned";
  commission_rate_override: number | null;
  payout_iban: string | null;
  payout_bic: string | null;
  payout_account_holder: string | null;
  ust_id: string | null;
  billing_full_name: string | null;
  billing_street: string | null;
  billing_zip: string | null;
  billing_city: string | null;
  billing_country: string | null;
  tax_status: "kleinunternehmer" | "vat" | null;
  application_message: string | null;
  approved_at: string | null;
  created_at: string;
}

export function useMyAffiliate(userId: string | undefined) {
  return useQuery({
    queryKey: ["my-affiliate", userId],
    enabled: !!userId,
    queryFn: async (): Promise<AffiliateRecord | null> => {
      if (!userId) return null;
      const { data, error } = await supabase
        .from("affiliates")
        .select("id, user_id, affiliate_code, status, commission_rate_override, payout_iban, payout_bic, payout_account_holder, ust_id, billing_full_name, billing_street, billing_zip, billing_city, billing_country, tax_status, application_message, approved_at, created_at")
        .eq("user_id", userId)
        .maybeSingle();
      if (error) throw error;
      return (data as AffiliateRecord | null) ?? null;
    },
    staleTime: 30_000,
  });
}
